import { Slider, Typography } from "@mui/material";
import React from "react";
import { numberWithCommas } from "utils/helpers";
import styles from "./Range.module.css";

function Range({ setEquityContribution, equityContribution }) {
  const handleChange = (e, value) => {
    setEquityContribution(value);
  };
  return (
    <div className={styles.range}>
      <div className={styles.label}>
        <Typography>Equity Contribution</Typography>
        <div className={styles.amount}>
          <Typography>₦ {numberWithCommas(equityContribution)}</Typography>
        </div>
      </div>
      <Slider
        key={`slider-${equityContribution}`}
        min={150000}
        step={10000}
        max={900000}
        defaultValue={equityContribution}
        aria-label="Default"
        valueLabelDisplay="auto"
        onChangeCommitted={handleChange}
      />
      <div className={styles.label_btm}>
        <Typography>1,500,000</Typography>
        <Typography>900,000,000</Typography>
      </div>
    </div>
  );
}

export default Range;
